<app-stages [stages]="stages" currentStage="Zdarzenie"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <div class="row">
      <div class='col-md-12'>
        <div class='form-group' *ngIf='"description" as controlName'>
          <label [for]='controlName'>
            Przyczyna zdarzenia *
          </label>
          <textarea
            rows="8"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu przyczynę zdarzenia'>
          </textarea>
          <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <app-exposed-map-control [alertMessage]="null" [control]="form.geometry"></app-exposed-map-control>
    <div class="row">
      <div class="col-12">
        <div class="form-group mb-0 mt-3">
          <div class="custom-radio custom-inline">
            <input (change)="form.provideRoadNumberAndNameChange(true)" name="provideRoadNumberAndName"
                   formControlName="provideRoadNumberAndName" type="radio"
                   id="provideRoadNumberAndNameTrue" [value]="true">
            <label for="provideRoadNumberAndNameTrue">
              Chcę wprowadzić numer i nazwę drogi
            </label>
          </div>
          <div class="custom-radio custom-inline">
            <input (change)="form.provideRoadNumberAndNameChange(false)" name="provideRoadNumberAndName"
                   formControlName="provideRoadNumberAndName" type="radio"
                   id="provideRoadNumberAndNameFalse" [value]="false">
            <label for="provideRoadNumberAndNameFalse">
              Chcę wprowadzić ulicę
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class='row'>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"city" as controlName'>
          <label [for]='controlName'>
            Miejscowość *
          </label>
          <select
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            (change)="form.cityChange()"
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            @if (form.provideRoadNumberAndName.value) {
              @for (item of form.townWithRoadsList(); track $index) {
                <option [value]='item.name'>{{ item.name }}</option>
              }
            } @else {
              @for (item of form.townWithStreetsList(); track $index) {
                <option [value]='item.name'>{{ item.name }}</option>
              }
            }
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      @if (form.roadNumber) {
        <div class='col-md-3'>
          <div class='form-group' *ngIf='"roadNumber" as controlName'>
            <label [for]='controlName'>
              Numer drogi *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              (change)="form.roadNumberChange(form.getElement($event).value)"
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @for (item of form.getRoadList(form.city.value); track $index) {
                <option [value]='item.roadNumber'>{{ item.roadNumber }}</option>
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.roadName) {
        <div class='col-md-5'>
          <div class='form-group' *ngIf='"roadName" as controlName'>
            <label [for]='controlName'>
              Nazwa drogi *
            </label>
            <input
              readonly
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu nazwę drogi'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.street) {
        <div class='col-md-6'>
          <div class='form-group' *ngIf='"street" as controlName'>
            <label [for]='controlName'>
              Ulica *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @for (item of form.getStreetList(form.city.value); track $index) {
                <option [value]='item.roadNumber + " - " + item.name'>{{ item.roadNumber + " - " + item.name }}
                </option>
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
    <br>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <div class="custom-radio">
            <input (change)="form.provideDateRangeDescriptionChange(false)" name="provideDateRangeDescription"
                   formControlName="provideDateRangeDescription" type="radio"
                   id="dateTimeRadio" [value]="false">
            <label for="dateTimeRadio">Chcę wprowadzić dokładną datę i godzinę zdarzenia</label>
          </div>
          <div class="custom-radio">
            <input (change)="form.provideDateRangeDescriptionChange(true)" name="provideDateRangeDescription"
                   formControlName="provideDateRangeDescription" type="radio"
                   id="dateRangeDescRadio" [value]="true">
            <label for="dateRangeDescRadio">Chcę opisać zakres lat</label>
          </div>
        </div>
      </div>
      @if (form.eventStartDate) {
        <div class="col-md-3">
          <div class='form-group' *ngIf='"eventStartDate" as controlName'>
            <label [for]='controlName'>
              Data zdarzenia *
            </label>
            <app-date-picker [id]='controlName' [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.eventStartTime) {
        <div class='col-md-3'>
          <div class='form-group' *ngIf='"eventStartTime" as controlName'>
            <label [for]='controlName'>
              Czas zdarzenia *
            </label>
            <input
              mask="Hh:m0"
              [dropSpecialCharacters]="false"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='00:00'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.dateRangeDescription) {
        <div class='col-md-12'>
          <div class='form-group' *ngIf='"dateRangeDescription" as controlName'>
            <label [for]='controlName'>
              Opis zakresu lat *
            </label>
            <textarea
              rows="4"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Opisz tu zakres lat'>
          </textarea>
            <app-validation-errors [maxTextLength]="1000" [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
    <div class="row">
      <div class='col-md-12'>
        <div class='form-group' *ngIf='"eventLocation" as controlName'>
          <label [for]='controlName'>
            Miejsce zdarzenia *
          </label>
          <textarea
            rows="8"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu miejsce zdarzenia'>
          </textarea>
          <app-validation-errors [maxTextLength]="255" [showTextLength]="true" [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-12'>
        <div class='form-group' *ngIf='"eventDescription" as controlName'>
          <label [for]='controlName'>
            Opis uszkodzeń *
          </label>
          <textarea
            rows="8"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Opisz tu uszkodzenia'>
          </textarea>
          <app-validation-errors [showTextLength]="false" [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <fieldset>
      <legend>
        Dane poszkodowanego
      </legend>
      <div class="row">
        <div class="col-md-8">
          <div class="form-group">
            <div class="custom-radio">
              <input (change)="form.injuredDataSameAsApplicantChange(false)" name="injuredDataSameAsApplicant"
                     formControlName="injuredDataSameAsApplicant" type="radio"
                     id="injuredDataNotSameAsApplicant" [value]="false">
              <label for="injuredDataNotSameAsApplicant">Chcę wprowadzić adresowe dane poszkodowanego</label>
            </div>
            <div class="custom-radio">
              <input (change)="form.injuredDataSameAsApplicantChange(true)" name="injuredDataSameAsApplicant"
                     formControlName="injuredDataSameAsApplicant" type="radio"
                     id="injuredDataSameAsApplicant" [value]="true">
              <label for="injuredDataSameAsApplicant">Adresowe dane poszkodowanego są takie same jak dane
                wnioskodawcy</label>
            </div>
          </div>
        </div>
      </div>
      <app-injured-person-form [form]="form.injuredPersonForm"></app-injured-person-form>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"injuredWas" as controlName'>
            <label [for]='controlName'>
              Poszkodowany był *
            </label>
            <select
              (change)="form.injuredWasChange(form.getElement($event).value)"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option value='Pieszym'>Pieszym</option>
              <option value='Kierowcą pojazdu mechanicznego'>
                Kierowcą pojazdu mechanicznego
              </option>
              <option value="Rowerzystą">
                Rowerzystą
              </option>
              <option value="Inne">
                Inne
              </option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        @if (form.injuredWasDesc) {
          <div class='col-md-8'>
            <div class='form-group' *ngIf='"injuredWasDesc" as controlName'>
              <label [for]='controlName'>
                Poszkodowany opis *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu kim był poszkodowany'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
      </div>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"damageType" as controlName'>
            <label [for]='controlName'>
              Rodzaj szkody *
            </label>
            <select
              (change)="form.damageTypeChange(form.getElement($event).value)"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option value='Osobowe'>Osobowe</option>
              <option value="Rzeczowe">
                Rzeczowe
              </option>
              <option value="Inne">Inne</option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        @if (form.damageTypeDesc) {
          <div class='col-md-8'>
            <div class='form-group' *ngIf='"damageTypeDesc" as controlName'>
              <label [for]='controlName'>
                Inny rodzaj szkody *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu rodzaj szkody'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
      </div>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"servicesNotifiedAboutEvent" as controlName'>
            <label [for]='controlName'>
              Służby powiadomione o zdarzeniu *
            </label>
            <select
              (change)="form.servicesNotifiedAboutEventChange(form.getElement($event).value)"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option value='Policja'>Policja</option>
              <option value="Straż Pożarna">Straż Pożarna</option>
              <option value='Straż Miejska'>Straż Miejska</option>
              <option value='Inne służby'>Inne służby</option>
              <option value='Brak'>Brak</option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        @if (form.servicesNotifiedAboutEventDesc) {
          <div class='col-md-8'>
            <div class='form-group' *ngIf='"servicesNotifiedAboutEventDesc" as controlName'>
              <label [for]='controlName'>
                Dane innych służb *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu dane innych służb'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
      </div>
      <div class="row">
        <div class='col-md-12'>
          <div class='form-group' *ngIf='"witnessStatement" as controlName'>
            <label [for]='controlName'>
              Oświadczenie świadka
            </label>
            <textarea
              rows="8"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu oświadczenie świadka'>
            </textarea>
            <app-validation-errors [showTextLength]="false" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
      <div class="row">
        <div class='col-md-12'>
          <div class='form-group' *ngIf='"additionalInformation" as controlName'>
            <label [for]='controlName'>
              Informacje dodatkowe
            </label>
            <textarea
              rows="8"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu informacje dodatkowe'>
            </textarea>
            <app-validation-errors [showTextLength]="false" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
  </form>
  <div class='application-actions'>
    <button
      type='button'
      class='btn btn-secondary'
      (click)='onCancel()'>
      <span>
        Wstecz
      </span>
    </button>
    <button
      type='button'
      class='btn btn-primary'
      (click)='submitAndGoNext()'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
